import { alpha } from '@mui/material';

const ROW_BG_ALPHA = 0.06;
const ROW_BORDER_ALPHA = 0.4;
const DOT_SIZE = 8;

/**
 * Resolve the palette color family for a finding severity, guarding against
 * themes that omit a key by falling back to a guaranteed palette entry.
 *
 * @param {Object} palette
 * @param {string} severity
 * @returns {Object}
 */
const resolveSeverityColor = (palette, severity) =>
  palette[severity] ?? palette.info ?? palette.primary;

export const lintPanelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '8px',
};

export const summaryBarStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '14px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.default,
  padding: '8px 14px',
};

export const getSummaryStatStyles = severity => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  fontWeight: 800,
  color: ({ palette }) => resolveSeverityColor(palette, severity).main,
});

export const getSummaryDotStyles = severity => ({
  width: `${DOT_SIZE}px`,
  height: `${DOT_SIZE}px`,
  borderRadius: '50%',
  backgroundColor: ({ palette }) => resolveSeverityColor(palette, severity).main,
});

export const findingsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const getFindingRowStyles = severity => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '6px 10px',
  borderRadius: ({ shape }) => shape.radius.m,
  backgroundColor: ({ palette }) =>
    alpha(resolveSeverityColor(palette, severity).main, ROW_BG_ALPHA),
  border: ({ palette }) =>
    `1px solid ${alpha(resolveSeverityColor(palette, severity).main, ROW_BORDER_ALPHA)}`,
});

export const getFindingDotStyles = severity => ({
  width: `${DOT_SIZE}px`,
  height: `${DOT_SIZE}px`,
  borderRadius: '50%',
  flexShrink: 0,
  marginTop: '6px',
  backgroundColor: ({ palette }) => resolveSeverityColor(palette, severity).main,
});

export const findingTextWrapStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
};

export const getFindingPinStyles = severity => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  marginLeft: 'auto',
  fontWeight: 800,
  borderRadius: ({ shape }) => shape.radius.xl,
  padding: '2px 10px',
  whiteSpace: 'nowrap',
  color: ({ palette }) => resolveSeverityColor(palette, severity).main,
  backgroundColor: ({ palette }) =>
    alpha(resolveSeverityColor(palette, severity).main, ROW_BG_ALPHA),
  border: ({ palette }) =>
    `1px solid ${alpha(resolveSeverityColor(palette, severity).main, ROW_BORDER_ALPHA)}`,
});
